import DeleteIcon from '@mui/icons-material/Delete'
import { Box, IconButton, TextField, Typography } from '@mui/material'
import React, { FC, useEffect, useState } from 'react'
import Hardware, { getHardwareParams } from '../../classes/Hardware'
import Item, { LinkType } from '../../classes/Item'
import useUnit, { useWeightUnit } from '../../hooks/useUnit'
import { Shift } from '../common/Helpers'
import { cmToInWithoutRound, kgToLbs } from '../common/UnitComponents'
import ParamComponent from './ParamComponent'

export const makeHardwareList = (
    item: Item,
    hardwares: Hardware[],
    deleteHardware: (localId: number) => void,
    addLink: (itemName: string, link: LinkType) => void,
    setItemPrice: () => void,
    setHardwareCount: (itemName: string, localId: number, count: number) => void,
    setParamCountHardwarePerCM: (itemName: string, localId: number, perCM: number) => void,
    openHardwareDetails: (hId: number) => void,
    parentID?: string,
    parentUpdate?: { value: number, change(value: number): void }
) => {

    return hardwares.map(h =>
        <HardwareComponent
            key={h.id + '_' + h.localId}
            item={item}
            hardware={h}
            parentID={parentID}
            parentUpdate={parentUpdate}
            deleteHardware={deleteHardware}
            addLink={addLink}
            setItemPrice={setItemPrice}
            setHardwareCount={setHardwareCount}
            setParamCountHardwarePerCM={setParamCountHardwarePerCM}
            openHardwareDetails={openHardwareDetails}
        // itemPropsName={itemPropsName}
        />)
}

interface IProps {
    item: Item
    hardware: Hardware
    parentID?: string
    parentUpdate?: {
        value: number
        change(value: number): void
    }

    deleteHardware(localId: number): void
    addLink(itemName: string, link: LinkType): void
    setItemPrice(): void
    setHardwareCount(itemName: string, localId: number, count: number): void
    setParamCountHardwarePerCM(itemName: string, localId: number, perCM: number): void
    openHardwareDetails(hId: number): void
}

const HardwareComponent: FC<IProps> = ({ item, hardware, parentID, parentUpdate, deleteHardware, addLink, setItemPrice, setHardwareCount, setParamCountHardwarePerCM, openHardwareDetails }) => {
    // const [count, setCount] = useState(hardware.count)
    const [update, setUpdate] = useState(0)

    const { unit } = useUnit()
    const { unit: weightUnit } = useWeightUnit()


    let childrenList = [] as Array<JSX.Element>

    if (hardware.children.length > 0) {
        if (parentID)
            childrenList = makeHardwareList(item, hardware.children, deleteHardware, addLink, setItemPrice, setHardwareCount, setParamCountHardwarePerCM, openHardwareDetails, `${hardware.localId}_${parentID}`, { value: update, change: setUpdate })
        else
            childrenList = makeHardwareList(item, hardware.children, deleteHardware, addLink, setItemPrice, setHardwareCount, setParamCountHardwarePerCM, openHardwareDetails, hardware.localId.toString(), { value: update, change: setUpdate })
    }

    useEffect(() => {
        if (parentUpdate)
            parentUpdate.change(parentUpdate.value + 1)

        setItemPrice()
    }, [update])

    const handleCountChange = (event: React.ChangeEvent<{ value: string }>) => {
        const count = parseInt(event.target.value)
        if (count > 0)
            setHardwareCount(item.name, hardware.localId, count)
    }

    const handlePerCmChange = (perCM: number, name: string) => {
        if (perCM > 0 && name === 'count') {
            setParamCountHardwarePerCM(item.name, hardware.localId, perCM)
        }
    }

    const getPrice = () => {
        // hardware.changeCount(count)
        return hardware.price
    }

    const getWeight = () => {
        return weightUnit === 'kg' ? hardware.weight : kgToLbs(hardware.weight)
    }

    return <Box
        key={hardware.name}
        mt={2} p={1}
        style={{
            border: '1px solid black',
            borderRadius: 7,
            background: 'white',
            marginRight: parentID?.split('_').length === 1 ? 48 : 0,
            columnGap: 20
        }}
        onClick={e => {
            if (e.ctrlKey)
                openHardwareDetails(hardware.id)
        }}
        display='flex'
        justifyContent='space-between'
    >
        <Box>
            <Box display='flex' alignItems='center'>
                <Typography>{hardware.name}</Typography>
                <Box sx={{ display: 'flex', width: 350, height: 56, overflowX: 'auto' }}>
                    {
                        getHardwareParams(hardware).map(param => {

                            const name = Object.keys(param)[0]

                            return <ParamComponent
                                key={name}
                                id={parentID ? `${hardware.localId}_${parentID}` : hardware.localId.toString()}
                                name={name}
                                type={hardware.type}
                                value={param[name].value}
                                extra={param[name].extra}
                                links={item.links}
                                handleChangeExtra={() => { }}
                                handlePerCmChange={handlePerCmChange}
                                parentItemProps={Object.keys(item.props).filter(prop => prop !== 'type')}
                                addLink={(itemProp: string, hId: string) => {
                                    addLink(item.name, {
                                        hId,
                                        hProp: name,
                                        itemProp
                                    })
                                }}
                            />
                        })
                    }
                </Box>
                {/* {h.props.type !== 'static' &&
                Object.keys(h.props).map(key => key !== 'type'
                    ?  : <></>)
            } */}
                <Shift />

            </Box>
            {(hardware.type.split('_')[1] === 'area' || hardware.type.split('_')[1] === 'cornerHorizontalSheet' || hardware.type.split('_')[1] === 'cornerTwoDoor') && <Box mt={1} display='flex' alignItems='center' >
                <TextField
                    label={"Cost Per " + unit}
                    variant="outlined"
                    size='small'
                    value={unit === 'cm' ? hardware.unitPriceAddon : cmToInWithoutRound(hardware.unitPriceAddon)}
                    type='number'
                    style={{
                        // width: 65,
                        marginRight: 10
                    }}
                    disabled
                />
                <TextField
                    label="Addon Per Piece"
                    variant="outlined"
                    size='small'
                    value={hardware.addonD}
                    type='number'
                    style={{
                        // width: 65,
                        marginRight: 10
                    }}
                    disabled
                />
                <TextField
                    label="Addon on %"
                    variant="outlined"
                    size='small'
                    value={hardware.addonP}
                    type='number'
                    style={{
                        // width: 65,
                        marginRight: 10
                    }}
                    disabled
                />
                <TextField
                    label="Minimum"
                    variant="outlined"
                    size='small'
                    value={hardware.minPrice}
                    type='number'
                    style={{
                        // width: 65,
                        marginRight: 10
                    }}
                    disabled
                />
            </Box>}

            {childrenList}
        </Box>
        <Box display='flex' alignItems='center' >
            <TextField
                label="Count"
                variant="outlined"
                size='small'
                value={hardware.count}
                type='number'
                onChange={handleCountChange}
                style={{
                    width: 65,
                    marginRight: 10
                }}
                disabled={!!parentID}
            />
            <Box>
                <Typography>${getPrice()}</Typography>
                <Typography>{getWeight()} {weightUnit}</Typography>
            </Box>

            {!parentID &&
                <IconButton
                    onClick={() => {
                        deleteHardware(hardware.localId)
                    }}>
                    <DeleteIcon />
                </IconButton>
            }
        </Box>
    </Box >
}

export default HardwareComponent